module.exports = __webpack_public_path__ + "img/img_12.d12dee48.png";